import React from "react";
import { connect } from "react-redux";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { shiftsDefinitionsPageLoad } from "../../actions/shifts-definitions";
import {
  isLoadingShiftsDefinitions,
  shiftsDefinitions,
  regionEngineers,
} from "../../selectors/shifts-definitions";
import Calendar from "../../components/calendar/ReadOnlyCalendar";
import { region } from "../../selectors/regions";
import { push } from "react-router-redux/actions";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";

const ConnectedCalendar = connect(
  (state, ownProps) => ({
    shiftsDefinitions: shiftsDefinitions(state),
    engineers: regionEngineers(state, ownProps.regionId),
    region: region(state),
    loading: isLoadingShiftsDefinitions(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(shiftsDefinitionsPageLoad(ownProps.regionId)),
    onRegionList: () => dispatch(push("/scheduling")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading Schedule..." />;
    }
    return [
      <PageTitle key="title" title={props.region.name} />,
      <Calendar
        key="calendar"
        onRegionList={props.onRegionList}
        shiftsDefinitions={props.shiftsDefinitions}
      />,
    ];
  }),
);

export default ({ match }) =>
  isNaN(match.params.regionId) ? (
    <PageNotFound />
  ) : (
    <ConnectedCalendar regionId={parseInt(match.params.regionId, 10)} />
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-tech/SchedulePage.js